import { schema } from 'normalizr';

const user = new schema.Entity('users');
const users = new schema.Array(user);

const attachment = new schema.Entity('attachments');
const attachments = new schema.Array(attachment);

export const message = new schema.Entity('messages', { attachments });
export const messages = new schema.Array(message);

const chat = new schema.Entity('chats', { users, messages });
export const chats = new schema.Array(chat);

const publicChannel = new schema.Entity('publicChannels');
export const publicChannels = new schema.Array(publicChannel);
